// src/pages/Privacypolicy.js
import React from 'react';

function Privacypolicy() {
    return (

        <>
            {/* <div className="p-6 "> */}
            <div className="border-2 border-[#d3c8bd80]   p-6 max-w-4xl  inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30 mx-auto  text-[#333] bg-white  rounded-xl mt-10">

                <div className="border-2 border-[#ecd8ca80] text-[#361A06] p-6 mt-4 lg:mt-0 rounded-xl bg-white shadow-xl w-full sm:max-w-lg md:max-w-4xl relative">
                    <p className='font-bold text-[24px] uppercase font-david text-[#FD8531]'>Shyama Yoga Studio</p>
                    <h1 className="text-4xl font-bold text-start text-[#361A06] mb-4">Privacy Policy</h1>
                    <p className="text-[24px] inline-block border-b border-[#9e7755] font-bold mb-4">
                        Effective Date: 14-06-2025
                    </p>

                    <p className="font-medium text-[#361A06] text-lg mb-4">
                        At Shyama Yoga Studio, your privacy is very important to us. This Privacy Policy outlines how
                        we collect, use, and protect your personal information.
                    </p>

                    <h2 className="font-bold text-xl text-[#361A06] mt-6 mb-2 inline-block border-b border-[#9e7755] ">1. Information We Collect</h2>
                    <p className='text-[#361A06] text-lg '>We may collect the following types of personal information when you interact with our website
                        or sign up for our programs:</p>
                    <ul className="list-disc ml-6  text-lg mb-4">
                        <li>Name</li>
                        <li>Email Address</li>
                        <li>Phone Number</li>
                        <li>Any other information you voluntarily provide</li>
                    </ul>

                    <h2 className="font-bold text-xl inline-block border-b border-[#9e7755]  mt-6 mb-2">2. How We Use Your Information</h2>
                    <p className='mb-4  text-lg '>
                        We use your personal information to:
                    </p>
                    <ul className="list-disc ml-6 mb-4 text-lg ">
                        <li>Register you for yoga programs</li>
                        <li>Send confirmations, updates, and reminders</li>
                        <li>Respond to your inquiries</li>
                        <li>Share info about our offerings, promotions, or events</li>
                    </ul>
                    <p className="mb-4 inline-block border-b border-[#9e7755]  font-bold">We Do Not Sell Or Share Your Information With Third-Party Marketers.</p>
                    <br />
                    <h2 className="font-bold text-xl inline-block border-b border-[#9e7755]  mt-8 mb-2">3. Data Security</h2>
                    <p className="mb-4 text-lg text-[#361A06]">
                        We take reasonable measures to protect your personal information from unauthorized access
                        or disclosure. However, no method of transmission over the internet is 100% secure.                    </p>

                    <h2 className="font-bold text-xl inline-block border-b border-[#9e7755]  mt-6 mb-2">4. Third-Party Services</h2>
                    <p className="mb-4 text-lg text-[#361A06]">
                        Our website may contain links to third-party services such as payment gateways or social media
                        platforms. We are not responsible for the privacy practices of these sites.
                    </p>

                    <h2 className="font-bold text-xl inline-block border-b border-[#9e7755]  mt-6 mb-2">5. Your Rights</h2>
                    <p className="mb-2 text-lg text-[#361A06]">You may request access to or deletion of your personal data by contacting us at:</p>
                    <p className="mb-1"><span className='font-bold text-[#361A06]'>Email:</span> Sharmila.Raghav@Shyama-Yoga.Com</p>

                    <p><span className='font-bold text-[#361A06]'>Phone:</span> 8500490000, 9951400096</p>
                    <h2 className="font-bold text-xl inline-block border-b border-[#9e7755]  mt-6 mb-2">6. Changes to This Policy</h2>
                    <p className="mb-4 text-lg text-[#361A06]">
                        We may update this privacy policy from time to time. Updates will be posted on this page with the revised date.
                    </p>

                    <h2 className="font-bold  text-xl inline-block border-b border-[#9e7755]  mt-6 mb-2">7. Contact Us</h2>
                    <p className='text-lg text-[#361A06]'>If you have any questions about this Privacy Policy, feel free to reach out:Shyama Yoga Studio.</p>

                    <p className="mb-1 mt-4"><span className='font-bold '>Address:</span> Diamond Point, Old Bowenpally, Secunderabad - 500009</p>
                    <p className="mb-1"><span className='font-bold text-[#361A06]'>Email:</span> Sharmila.Raghav@Shyama-Yoga.Com</p>
                    <p><span className='font-bold text-[#361A06]'>Phone:</span> 8500490000, 9951400096</p>
                </div>
            </div>
        </>
    );
}

export default Privacypolicy;
